addEventListener('DOMContentLoaded', _ => {
    Object.defineProperty(document, 'top', {
        get() {
            return (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0)
        },
    })
    const navElement = document.querySelector('#navigation')
    const nextSibling = navElement.parentElement.querySelector('#navigation + *')
    const mirror = navElement.cloneNode(true)
    mirror.classList.add('mirror')
    navElement.parentElement.insertBefore(mirror, nextSibling)
    addEventListener('scroll', _ => {
        if (document.top > navElement.clientHeight + 200) {
            navElement.classList.add('scrolled')
        } else {
            navElement.classList.remove('scrolled')
        }
    })

    const hamburger = document.querySelector('#nav-toggle')
    const navItems = document.querySelector('#navigation-items')

    const navItemMobileWrapper = document.querySelector('#navigation-items-wrapper');

    hamburger.addEventListener('click', _ => {
        navItemMobileWrapper.classList.toggle('open')
        hamburger.classList.toggle('opened')
    });

    const navItemDropdownLinks = navItems.querySelectorAll('.down-arrow');
    navItemDropdownLinks.forEach(elem => {
        elem.addEventListener('click', ev => {
            const dropdown = ev.target.parentElement.parentElement.querySelector('.dropdown-menu');
            const dropdownSub = ev.target.parentElement.parentElement.querySelector('.dropdown-submenu');

            ev.target.parentElement.parentElement.classList.toggle('dropdown-open');

            if (dropdown) {
                if (ev.target.href) {
                    if (!ev.target.dataset.clicked) {
                        ev.target.setAttribute('data-clicked', 'true');
                        ev.preventDefault();
                    }

                    let isActive = false;
                    if (dropdown.classList.contains('active')) {
                        isActive = true;
                    }
    
                    const activeRootItems = navItems.querySelectorAll('.dropdown-menu.active');
                    activeRootItems.forEach(elem => {
                        const subItems = elem.querySelectorAll('.dropdown-submenu');
                        const subItemLinks = elem.querySelectorAll('.down-arrow[data-clicked=true]');
    
                        subItems.forEach(elem => {
                            elem.classList.remove('active');
                        });
    
                        subItemLinks.forEach(elem => {
                            elem.removeAttribute('data-clicked');
                        })
    
                        elem.classList.toggle('active');
                    });
    
    
                    if (!isActive) {
                        dropdown.classList.add('active');
                    }
                }
            } else if (dropdownSub) {
                if (ev.target.href) {
                    if (!ev.target.dataset.clicked) {
                        ev.target.setAttribute('data-clicked', 'true');
                        ev.preventDefault();
                    }
                    
                    const siblingLinks = ev.target.parentElement.parentElement.querySelectorAll('.down-arrow[data-clicked=true]');
                    siblingLinks.forEach(elem => {
                        if (elem.id !== ev.target.id) {
                            elem.removeAttribute('data-clicked');
                        }
                    })

                    const activeChildItems = navItems.querySelectorAll('.dropdown-submenu.active');
                    activeChildItems.forEach(elem => {
                        elem.classList.toggle('active');
                    });

                    dropdownSub.classList.toggle('active');
                }
            }
        })
    });

    const navLinksWrapper = document.querySelector('.navigation-links-wrapper');
    const navItemsWrapper = document.querySelector('.nav-menu-items-wrapper');

    function moveNavItems() {
        if (navItemsWrapper) {
            if (window.innerWidth < 992) {
                if (!navItemMobileWrapper.contains(navItemsWrapper)) {
                    navItemMobileWrapper.insertBefore(navItemsWrapper, navItemMobileWrapper.firstChild);
                }
            } else {
                if (!navLinksWrapper.contains(navItemsWrapper)) {
                    navLinksWrapper.appendChild(navItemsWrapper);
                }
            }
        }
    }

    window.addEventListener('resize', _ => {
        moveNavItems();
    });

    moveNavItems();
});
